"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
exports.resetStore = function (storageClearingList) {
    return toolkit_1.createAction(constants_1.RESET_STORE)({ storageClearingList: storageClearingList });
};
exports.rehydrateStore = function (persistStore) { return toolkit_1.createAction(constants_1.REHYDRATE_STORE)({ persistStore: persistStore }); };
exports.setNavigationReady = function (isLoading) {
    return toolkit_1.createAction(constants_1.SET_NAVIGATION_READY)(isLoading);
};
exports.setEPGDayLoaded = function (dayCode, etag) {
    return toolkit_1.createAction(constants_1.SET_EPG_DAY_LOADED)({ dayCode: dayCode, etag: etag });
};
exports.removeEPGDayLoaded = function (dayCode) {
    return toolkit_1.createAction(constants_1.REMOVE_EPG_DAY_LOADED)({ dayCode: dayCode });
};
//# sourceMappingURL=actions.js.map